<template>
  <ul v-if="tags" class="tagList">
    <li v-for="item in tags" :key="item" class="goods_tag">{{ item }}</li>
  </ul>
</template>
<script>
export default {
  props: ['tags'],
};
</script>
<style lang="scss" scoped>
.tagList {
  line-height: 0;
  overflow: hidden;

  li {
    float: left;
    margin-top: 10px;
    margin-right: 5px;
  }
}
</style>

